<template>
  <div ref="recipeCard" :class="cardClasses">
    <div ref="imageContainer" @click="selectRecipe" :class="styles" :style="recipeStyle">
      <div :class="['image-overlay',meta_classes]"></div>
    </div>
    <div class="recipe-info">
      <div class="recipe-title">{{ recipe.title }}</div>
      <div class="recipe-details">
        <div class="recipe-macros">
          <span class="macro calories">
            <span class="label">Calories:</span>
            {{ recipe.macros.calories }}
          </span>
          <span class="macro cook-time">
            <span class="label">Time:</span>
            {{ recipe.cooking_time_in_minutes }}min
          </span>
        </div>
      </div>
      <div v-if="!hidePrices" class="recipe-price">
        <span v-mny="{ input: recipe_price, currency: 'GBP' }"></span>
        <span class="recipe-price-pp" v-if="meal_preferences.people>1">
          -
          <span v-mny="{ input: per_person, currency: 'GBP' }"></span>&nbsp;each person
        </span>
      </div>
      <div class="recipe-add-button">
        <span v-if="!isInCart(recipe)">
          <button
            v-if="!disablePurchase"
            @click="addToBasket"
            class="btn btn-primary card-button"
          >Add To Box</button>
        </span>
        <span v-else>
          <button
            v-if="!disablePurchase"
            @click="removeFromBasket"
            class="btn btn-primary card-button"
          >Remove</button>
        </span>
        <button
          v-if="allowDetails"
          @click="selectRecipe"
          class="btn btn-primary btn-secondary card-button"
        >Recipe Info</button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import { basketBase } from "../../components/cart/basketBase";

export default {
    name: 'recipe-card',
    mixins: [ basketBase ],
    props: {
        recipe: Object,
        hoverable: Boolean,
        isInBasket: Boolean,
        disablePurchase: Boolean,
        hidePrices: Boolean,
        allowDetails: Boolean,
        unHighlightSelected: Boolean
    },
    data: () => {
        return {
            style: ''
        }
    },
    computed: {
        ...mapState({
            meal_preferences: state => state.profile.meal_preferences,
            items: state => state.basket.items
        }),
        styles: function() {
            return ['recipe-image','image-blok','square'];
        },
        cardClasses: function() {
            return [
                'blok-container recipe-card hoverable ' + (this.isInCart(this.recipe) && !this.$props.unHighlightSelected ? 'selected' : '')
            ]
        },
        recipeStyle: function() {
            return {
                backgroundImage: `url(${this.recipe.image_urls.m})`
            }
        },
        recipe_price: function() {
            return (this.recipe.fractional_prices_for_portions[this.meal_preferences.people]/100)
        },
        per_person: function() {
            return this.recipe_price / this.meal_preferences.people;
        },
        meta_classes: function() {
          const vegan = this.recipe.food_group == 'Vegan' ? 1 : 0;
          const quick = this.recipe.cooking_time_in_minutes<20 ? 2 : 0;
          const specials = this.recipe.specials.length>0 ? 4 : 0;
          const group = vegan | quick | specials;
          switch(group) {
            case 0:
              return '';
            case 1:
              return 'vegan';
            case 2:
              return 'quick';
            case 3:
              return 'vegan-quick';
            case 4:
              return 'special';
            case 5:
              return 'vegan-special';
            case 6:
              return 'quick-special';
            case 7:
              return 'vegan-quick-special';
          }
          return ''
        }
    },
    mounted: function() {
        this.$emit('recipeView', this.recipe);
    },
    methods: {
        selectRecipe: function() {
            this.$emit('selectRecipe', this.recipe);
        },
        addToBasket: function() {
            this.$emit('addToBasket',this.recipe);
        },
        removeFromBasket: function() {
            this.$emit('removeFromBasket',this.recipe);
        }
    }
}
</script>
